"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GridNormalCellRenderer = void 0;
const react_1 = __importStar(require("react"));
const GridNormalCellRenderer_styles_1 = require("./GridNormalCellRenderer.styles");
const helpers_1 = require("../../../../../helpers");
exports.GridNormalCellRenderer = (0, react_1.memo)(({ isHighlighted, disabled, inactive, hasBigLeftIntent, hasPaddings = true, innerRef, textJustifyEnd, onMouseEnter, onMouseLeave, children, columnId }) => {
    return (react_1.default.createElement(GridNormalCellRenderer_styles_1.StyledGridNormalCell, { isHighlighted: isHighlighted, disabled: disabled, inactive: inactive, "data-column-id": columnId, hasBigLeftIntent: hasBigLeftIntent, hasPaddings: hasPaddings, className: (0, helpers_1.cn)('vm-GridNormalCell', isHighlighted && 'cell-highlighted') },
        react_1.default.createElement(GridNormalCellRenderer_styles_1.StyledGridNormalCellContent, { ref: innerRef, textJustifyEnd: textJustifyEnd, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, className: "vm-GridNormalCellContent" }, children)));
});
exports.GridNormalCellRenderer.displayName = 'GridNormalCellRenderer';
//# sourceMappingURL=GridNormalCellRenderer.js.map